<template>
    <div>
        <button class="iconfont icon-shangyiyehoutuifanhui-yuankuang" @click='$router.back()'>回退</button>
    </div>
</template>

<script>
export default {
    data() {
        return {

        };
    },
};
</script>

<style  scoped>

</style>
